module.exports = __webpack_public_path__ + "static/media/subscription2.17ba58ba.svg";